module.exports = __webpack_public_path__ + "img/icon-our-service.6108735a.png";